module.exports = __webpack_public_path__ + "assets/GTAmerica-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Bold.eot
// module id = 994
// module chunks = 19